import type { TranslationDict } from "./en.js";

const zh_CN: TranslationDict = {
  // Navbar
  "nav.myVideos": "我的视频",
  "nav.users": "用户",
  "nav.upload": "上传",
  "nav.profile": "个人资料",
  "nav.signOut": "退出",
  "nav.signIn": "登录",

  // Common
  "common.loading": "加载中...",
  "common.cancel": "取消",
  "common.delete": "删除",
  "common.save": "保存",
  "common.saving": "保存中...",
  "common.deleting": "删除中...",
  "common.adding": "添加中...",
  "common.unknown": "未知",
  "common.you": "你",
  "common.audio": "音频",
  "common.default": "默认",

  // Theme
  "theme.system": "系统",
  "theme.light": "浅色",
  "theme.dark": "深色",

  // Language
  "language.en": "English",
  "language.zh_HK": "繁體中文",
  "language.zh_CN": "简体中文",

  // Status
  "status.NEW": "新建",
  "status.QUEUED": "排队中",
  "status.PROCESSING": "处理中",
  "status.READY": "就绪",
  "status.FAILED": "失败",

  // Visibility
  "visibility.public": "公开",
  "visibility.private": "私密",
  "visibility.protected": "受保护",

  // Monetization
  "monetization.free": "免费",
  "monetization.sub": "订阅",
  "monetization.svod": "SVOD",
  "monetization.tvod": "TVOD",
  "monetization.ads": "广告",

  // Time
  "time.justNow": "刚刚",
  "time.minuteAgo": "{n} 分钟前",
  "time.minutesAgo": "{n} 分钟前",
  "time.hourAgo": "{n} 小时前",
  "time.hoursAgo": "{n} 小时前",
  "time.dayAgo": "{n} 天前",
  "time.daysAgo": "{n} 天前",
  "time.monthAgo": "{n} 个月前",
  "time.monthsAgo": "{n} 个月前",
  "time.yearAgo": "{n} 年前",
  "time.yearsAgo": "{n} 年前",

  // Login page
  "login.title": "登录",
  "login.email": "邮箱",
  "login.password": "密码",
  "login.submit": "登录",
  "login.signingIn": "登录中...",
  "login.hint": "使用通过 ADMIN_EMAIL / ADMIN_PASSWORD 配置的管理员账户登录。",

  // Home page
  "home.search": "搜索视频或标签",
  "home.noVideosMatch": "没有符合条件的视频",
  "home.noVideosYet": "暂无视频",
  "home.uploadToStart": "上传一个视频以开始。",
  "home.loadFailed": "加载视频失败：{error}",

  // Upload page
  "upload.title": "上传视频",
  "upload.noPermission": "你没有权限上传视频。请以发布者或管理员身份登录。",
  "upload.titleLabel": "标题",
  "upload.videoFile": "视频文件",
  "upload.monetization": "盈利方式",
  "upload.requiredTier": "所需等级（可选）",
  "upload.requiredTierPlaceholder": "例如 standard",
  "upload.visibility": "可见性",
  "upload.visibility.public.desc": "你的租户中的所有人都可以查看和播放此视频",
  "upload.visibility.private.desc": "只有你可以查看和播放此视频",
  "upload.visibility.protected.desc": "只有你和下方选择的用户可以查看和播放此视频",
  "upload.grantAccess": "授予访问权限",
  "upload.loadingUsers": "加载用户中...",
  "upload.selectUser": "请选择至少一个用户（或切换为私密）",
  "upload.renditionProfiles": "转码配置文件",
  "upload.tags": "标签（可选）",
  "upload.tagPlaceholder": "输入标签后按 Enter",
  "upload.step.details": "详情",
  "upload.step.upload": "上传",
  "upload.step.publish": "发布",
  "upload.step.ready": "就绪",
  "upload.uploading": "上传中... {percent}%",
  "upload.ingesting": "状态：{status} — 处理将在后台继续。完成后此页面将更新。",
  "upload.publish": "发布视频",
  "upload.processing": "处理中...",
  "upload.ready": "你的视频已就绪！",
  "upload.watchNow": "立即观看",
  "upload.backToHome": "返回首页",
  "upload.transcodeFailed": "转码失败。请在观看页面查看资产的工作详情。",
  "upload.addTag": "添加标签",
  "upload.titlesLabel": "标题",
  "upload.file": "个文件",
  "upload.files": "个文件",
  "upload.fillAllTitles": "请填写所有标题。",

  // My Videos page
  "myVideos.title": "我的视频",
  "myVideos.uploadNew": "上传新视频",
  "myVideos.empty": "你尚未上传任何视频",
  "myVideos.uploadFirst": "上传你的第一个视频",
  "myVideos.noPermission": "你没有权限管理视频。",
  "myVideos.processing": "处理中",
  "myVideos.processingNote": "正在转码",
  "myVideos.published": "已发布",
  "myVideos.publishedNote": "已上线且可观看",
  "myVideos.drafts": "草稿（未上传）",
  "myVideos.draftsNote": "已创建但未上传源文件 — 删除以清理",
  "myVideos.failed": "失败",
  "myVideos.failedNote": "转码失败 — 删除以移除损坏的视频",

  // Watch page
  "watch.processing": "排队处理中...",
  "watch.transcoding": "转码进行中...",
  "watch.failed": "此视频处理失败",
  "watch.processingNote": "此视频仍在处理中。转码完成后将自动开始播放。",
  "watch.renditions": "转码版本",
  "watch.audioTracks": "音轨",
  "watch.noAudioTracks": "无音轨",
  "watch.processingJobs": "处理任务",
  "watch.editVisibility": "编辑可见性",
  "watch.delete": "删除",
  "watch.channel": "频道",
  "watch.noTags": "无标签",
  "watch.deleteTitle": "删除视频",
  "watch.deleteMessage": "你确定要删除「{title}」吗？这将永久移除视频及其所有文件。",
  "watch.editVisibilityTitle": "编辑可见性",
  "watch.grantAccess": "授予访问权限",
  "watch.attachAudio": "附加音频",
  "watch.attaching": "附加中...",

  // Users page
  "users.title": "用户管理",
  "users.onlyAdmin": "只有管理员可以管理用户。",
  "users.addNew": "添加新用户",
  "users.email": "邮箱",
  "users.password": "密码",
  "users.role": "角色",
  "users.role.viewer": "观众",
  "users.role.publisher": "发布者",
  "users.role.admin": "管理员",
  "users.addUser": "添加用户",
  "users.users": "用户（{n}）",
  "users.deleteTitle": "删除用户",
  "users.deleteMessage": "你确定要删除「{email}」吗？这将移除其账户。其上传的视频将保留，但上传者链接将被清除。",

  // Titles
  "titles.title": "标题",
  "titles.edit": "编辑",
  "titles.add": "添加",
  "titles.addPlaceholder": "输入标题",

  // Profile page
  "profile.title": "个人资料",
  "profile.account": "账户",
  "profile.email": "邮箱",
  "profile.displayName": "显示名称",
  "profile.displayNamePlaceholder": "你的显示名称",
  "profile.preferences": "偏好设置",
  "profile.language": "语言",
  "profile.theme": "主题",
  "profile.changePassword": "修改密码",
  "profile.currentPassword": "当前密码",
  "profile.newPassword": "新密码",
  "profile.confirmPassword": "确认新密码",
  "profile.passwordChanged": "密码修改成功。",
  "profile.profileSaved": "个人资料已保存。",
  "profile.passwordMismatch": "两次输入的新密码不一致。",
  "profile.passwordTooShort": "新密码至少需要 6 个字符。",
};

export default zh_CN;
